import axios from "@/api/axiosInstance";
import {
  FetchKPIOverviewRequest,
  FetchKPIOverviewResponse,
  KPIOverviewResult,
} from "./types";

export const fetchKPIOverview = async (
  params: FetchKPIOverviewRequest,
  signal?: AbortSignal,
): Promise<KPIOverviewResult> => {
  const response = await axios.get<FetchKPIOverviewResponse>(
    "/api/private/admin/kpi-overview",
    { params, signal },
  );
  return {
    companyKPIOverviews: response.data.data.companyKPIOverviews,
    segmentCounts: response.data.data.segmentCounts,
    totalCount: response.data.meta?.totalCount ?? 0,
  };
};
